import { render, staticRenderFns } from "./ModalForCustomers.vue?vue&type=template&id=6e51e20c&"
import script from "./ModalForCustomers.vue?vue&type=script&lang=js&"
export * from "./ModalForCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalForCustomers.vue"
export default component.exports